(function () {
  'use strict';
  if (window.__agcfCartAug) return;
  window.__agcfCartAug = true;
  var SUR = {"vid": 46054424543292, "unit": 10, "fixture": false};
  var C = { cart: null, armed: false, polled: false };
  var IMGC = {}; /* render url -> 'load'|'late'|'warm'|'dead' */
  var FB = {};   /* cart line key -> banked theme thumb src */
  function money(cents) {
    var v = Math.abs(Math.round(cents));
    var s = '$' + Math.floor(v / 100).toLocaleString('en-US');
    var c = v % 100;
    if (c) s += '.' + (c < 10 ? '0' : '') + c;
    return (cents < 0 ? '-' : '') + s;
  }
  function paintAll() {
    if (!C.armed || !C.cart) return;
    try { paintDrawer(); } catch (e) {}
    try { paintCartPage(); } catch (e) {}
  }
  function prewarm(url) {
    if (!url || !/^https?:/.test(url) || IMGC[url]) return;
    IMGC[url] = 'load';
    var im = new Image();
    im.onload = function () {
      var fin = function () { IMGC[url] = 'warm'; paintAll(); };
      if (im.decode) { im.decode().then(fin, fin); } else { fin(); }
    };
    im.onerror = function () { IMGC[url] = 'dead'; paintAll(); };
    setTimeout(function () {
      if (IMGC[url] === 'load') { IMGC[url] = 'late'; paintAll(); }
    }, 900);
    im.src = url;
  }
  function memo(cart) {
    if (!cart || !cart.items || typeof cart.item_count !== 'number') return;
    C.cart = cart;
    if (!C.armed) return; /* PDP: store only - agcf.js owns the paint */
    cart.items.forEach(function (it) {
      var pv = (it.properties || {})['_preview'];
      if (pv) prewarm(pv);
    });
    paintAll();
  }
  function surFor(items, p) {
    for (var i = 0; i < items.length; i++) {
      if (!SUR.vid || items[i].variant_id !== SUR.vid) continue;
      var sp = items[i].properties || {};
      if (sp['_surcharge_for'] === p['_finish_codes']) return items[i];
    }
    return null;
  }
  function paintRow(row, it, img, titleHost, priceEl, useLinePrice) {
    var p = it.properties || {};
    if (SUR.vid && it.variant_id === SUR.vid) {
      row.classList.add('is-agcf-sur');
      return;
    }
    if (!p['Custom Finishing']) return;
    row.classList.add('is-agcf-cline');
    var pv = p['_preview'] || '';
    if (img && pv) {
      var ist = IMGC[pv];
      if (!ist) { prewarm(pv); ist = IMGC[pv]; }
      if (ist === 'warm' || ist === 'late') {
        row.classList.remove('is-agcf-imgwait');
        if (ist === 'warm' && img.getAttribute('src') !== pv) {
          if (!(it.key in FB)) FB[it.key] = img.getAttribute('src') || '';
          (function (u8, k8, im8) {
            im8.onerror = function () {
              im8.onerror = null;
              IMGC[u8] = 'dead';
              var fb = FB[k8];
              if (fb && im8.getAttribute('src') !== fb) im8.src = fb;
            };
          })(pv, it.key, img);
          img.src = pv;
        }
      } else if (ist === 'load' && !useLinePrice) {
        /* drawer only: /cart rows are SSR-visible - hiding a visible
           thumb would flash blank, so they swap in place when warm */
        row.classList.add('is-agcf-imgwait');
      } else {
        row.classList.remove('is-agcf-imgwait');
      }
    }
    if (titleHost && !row.querySelector('.agcf-cart-variant')) {
      var v = document.createElement('div');
      v.className = 'agcf-cart-variant';
      v.textContent = 'Custom Finishing: ' + p['Custom Finishing'];
      titleHost.insertAdjacentElement('afterend', v);
    }
    var sur = surFor((C.cart && C.cart.items) || [], p);
    if (sur && priceEl) {
      var upi = parseInt((sur.properties || {})['_units_per_item'],
                         10) || 0;
      if (upi) {
        var cents = useLinePrice
          ? it.final_line_price + upi * it.quantity * SUR.unit * 100
          : it.price + upi * SUR.unit * 100;
        var want = money(cents);
        if (priceEl.textContent.trim() !== want) {
          priceEl.textContent = want;
        }
      }
    }
  }
  function paintDrawer() {
    var items = C.cart.items || [];
    var rows = document.querySelectorAll(
      '#cart-drawer-items .cart-drawer__item');
    for (var i = 0; i < rows.length; i++) {
      var input = rows[i].querySelector('.quantity__input[data-index]');
      var idx = input ? parseInt(input.getAttribute('data-index'), 10) : 0;
      var it = idx ? items[idx - 1] : null;
      if (!it) continue;
      var lk = rows[i].querySelector('.cart-drawer__item-link');
      if (lk && it.url && lk.getAttribute('href') !== it.url) continue;
      paintRow(rows[i], it,
               rows[i].querySelector('.cart-drawer__item-image-img'),
               rows[i].querySelector('.cart-drawer__item-title'),
               rows[i].querySelector('.cart-drawer__item-price'),
               false);
    }
  }
  function paintCartPage() {
    var items = C.cart.items || [];
    var grids = document.querySelectorAll('.cart_grid');
    var rows = [];
    for (var i = 0; i < grids.length; i++) {
      if (grids[i].querySelector('input[name="updates[]"]')) {
        rows.push(grids[i]);
      }
    }
    if (rows.length !== items.length) return; /* mid-rebuild: next paint */
    for (var j = 0; j < rows.length; j++) {
      var it = items[j];
      var lk = rows[j].querySelector('a[href*="/products/"]');
      if (lk && it.url && lk.getAttribute('href') !== it.url) continue;
      var ti = rows[j].querySelector('.cart_info-order');
      var pr = rows[j].querySelector('.cart_price-info .text-size-regular');
      paintRow(rows[j], it,
               rows[j].querySelector('.cart_image'),
               ti ? (ti.firstElementChild || ti) : null,
               pr, true);
    }
  }
  /* observe-only tap, installed at PARSE time (before the deferred
     drawer constructor's first refreshCart). Full-cart responses only;
     request and promise pass through untouched. */
  if (!window.__agcfDrwTap && typeof window.fetch === 'function') {
    window.__agcfDrwTap = true;
    var nf = window.fetch;
    window.fetch = function (input) {
      var pr = nf.apply(this, arguments);
      try {
        var u = String((typeof input === 'string')
          ? input : (input && input.url) || '');
        var ii = arguments[1];
        var m = ii && ii.method
          ? String(ii.method).toUpperCase() : 'GET';
        if ((m === 'GET' && /\/cart\.js(on)?(\?|$)/.test(u))
            || (m === 'POST'
                && /\/cart\/(change|update)(\.js)?(\?|$)/.test(u))) {
          pr.then(function (r) {
            if (r && r.ok && r.clone) {
              r.clone().json().then(memo, function () {});
            }
          }, function () {});
        }
      } catch (e) {}
      return pr;
    };
  }
  function arm() {
    if (window.__agcfDrawerOwner === 'agcf') return; /* PDP module owns */
    window.__agcfDrawerOwner = 'agcf-cart';
    C.armed = true;
    /* R40: C.armed is closure-local, and the owner string is NOT a witness
       for it - agcf.js overwrites the owner afterwards, so a page where this
       file wrongly armed still reads 'agcf'. Publish the fact itself so
       qa_port R40-4 can assert the augment stayed OFF on a PDP. Set only on
       the armed path: absent means never armed. */
    window.__agcfCartArmed = true;
    var host = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer');
    if (host && window.MutationObserver) {
      /* the theme rebuilds drawer rows wholesale on every page load and
         twice per open - the paint runs inside its own mutation
         microtask (idempotent, so the burst terminates) */
      new MutationObserver(paintAll).observe(host,
        { childList: true, subtree: true });
    }
    if (C.cart) { memo(C.cart); } else { paintAll(); }
    setTimeout(function () {
      /* single-shot fallback: the ONE network request this file may
         originate, only when no tap-fed cart ever arrived */
      if (C.cart || C.polled) return;
      C.polled = true;
      fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(memo)
        .catch(function () {});
    }, 2500);
  }
  /* R40: this file's tag ships `defer` too, and it sits in the HEADER, so
     among the deferred scripts it executes FIRST - before agcf.js has
     declared ownership. At that moment readyState is already 'interactive'
     and DOMContentLoaded has not fired, so the frozen `=== 'loading'`
     predicate took the else-branch and armed on a PDP the module owns:
     owner 'agcf-cart', C.armed true, the drawer observer installed, both
     files painting. agcf.js then overwrites the owner back to 'agcf', so
     the FINAL value looks correct while the augment is live - a defect a
     `__agcfDrawerOwner === 'agcf'` check cannot see (qa_port R40-4 asks
     whether this file armed, which is the thing that matters).
     `!== 'complete'` differs in exactly one state, 'interactive', which is
     exactly and only the deferred window; the handshake goes back to
     resolving at DCL, after every deferred script has run. */
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();
